export default __webpack_public_path__ + "static/media/front_page_4.97fb7198.jpg";